import { render, staticRenderFns } from "./Typeahead.vue?vue&type=template&id=ac2ef9f0&lang=pug&"
import script from "./Typeahead.vue?vue&type=script&lang=ts&"
export * from "./Typeahead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac2ef9f0')) {
      api.createRecord('ac2ef9f0', component.options)
    } else {
      api.reload('ac2ef9f0', component.options)
    }
    module.hot.accept("./Typeahead.vue?vue&type=template&id=ac2ef9f0&lang=pug&", function () {
      api.rerender('ac2ef9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Typeahead.vue"
export default component.exports